"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _useInifiniteCarousel = require("./use-inifinite-carousel");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _text = _interopRequireDefault(require("@ux/text"));
var _carouselControl = _interopRequireDefault(require("../../sections/smart-testimonials-section/carousel-control"));
var _index = _interopRequireDefault(require("../../../experiments/animation/motion-move/index"));
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _reactIntersectionObserver = require("react-intersection-observer");
var _galleryItem = _interopRequireDefault(require("./gallery-item"));
var _base = require("@site/pattern-library-utils/base.functions");
var _index2 = _interopRequireDefault(require("../video-lightbox/index"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionContainer",
  class: "pl-s1gxvhan"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "HeadlineWrapper",
  class: "pl-hnlrlgr"
});
const GalleryContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GalleryContainer",
  class: "pl-g17fxym9"
});
const BottomWrapper = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "BottomWrapper",
  class: "pl-b4oumz5"
});
const ControlWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ControlWrapper",
  class: "pl-cdrkg5q"
});
const Caption = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Caption",
  class: "pl-cco777c"
});
function VideoGallerySection({
  id,
  _name,
  cards,
  sectionHeading,
  partial = '',
  verticalMargin
}) {
  const [lightBoxIsOpen, setLightBoxIsOpen] = (0, _react.useState)(false);
  const [selectedVideo, setSelectedVideo] = (0, _react.useState)(null);
  const {
    ref: inViewRef,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin: '200px 0px'
  });
  const {
    containerRef,
    extendedItems,
    activeExtendedIndex,
    handleNext,
    handlePrev
  } = (0, _useInifiniteCarousel.useInfiniteCarousel)(cards);
  const combinedRef = (0, _react.useCallback)(node => {
    if (node) {
      inViewRef(node);
      containerRef.current = node;
    }
  }, [inViewRef, containerRef]);
  const openLightBox = item => {
    setSelectedVideo(item);
    setLightBoxIsOpen(true);
  };
  const closeLightBox = () => setLightBoxIsOpen(false);
  const activeItem = extendedItems[activeExtendedIndex];
  const currentCaption = activeItem?.captionText || '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SectionContainer, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "video-gallery-section",
    padding: "none",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    mode: "fluid",
    intensity: "300",
    variant: "moveUpFixed",
    triggerOnce: true
  }, /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    as: "heading",
    size: 5,
    className: "section-heading",
    text: sectionHeading
  })), /*#__PURE__*/_react.default.createElement(GalleryContainer, {
    "data-cy": "gallery-container",
    ref: combinedRef
  }, extendedItems.map((item, index) => {
    const isActive = index === activeExtendedIndex;
    const {
      heading,
      landscape,
      portrait,
      thumbnailDesktop,
      thumbnailMobile,
      introUrl,
      introUrlWebm,
      introUrlLaptop,
      introUrlLaptopWebm,
      invert,
      lightboxUrl,
      youTubeId,
      disableAutoPlay,
      preload
    } = item || {};
    const handlePlay = () => openLightBox({
      lightboxUrl,
      youTubeId,
      disableAutoPlay
    });
    return /*#__PURE__*/_react.default.createElement(_galleryItem.default, {
      id: id,
      key: index,
      headlineProps: {
        heading
      },
      landscape: landscape,
      portrait: portrait,
      thumbnailDesktop: thumbnailDesktop,
      thumbnailMobile: thumbnailMobile,
      introUrlLaptop: introUrlLaptop,
      introUrlLaptopWebm: introUrlLaptopWebm,
      introUrl: introUrl,
      introUrlWebm: introUrlWebm,
      preload: preload,
      partial: partial,
      invert: invert,
      inView: inView,
      lightboxUrl: lightboxUrl,
      youTubeId: youTubeId,
      handlePlay: handlePlay,
      pause: !isActive,
      isCenteredIndex: !isActive,
      index: index
    });
  })), /*#__PURE__*/_react.default.createElement(BottomWrapper, {
    mode: "fluid",
    intensity: "200",
    variant: "moveUpFixed",
    triggerOnce: true
  }, currentCaption && /*#__PURE__*/_react.default.createElement(Caption, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: 0,
    text: currentCaption
  })), /*#__PURE__*/_react.default.createElement(ControlWrapper, null, cards?.length > 1 && /*#__PURE__*/_react.default.createElement(_carouselControl.default, {
    handleNextButtonClick: handleNext,
    handlePrevButtonClick: handlePrev,
    prevButtonAriaLabel: "previous",
    nextButtonAriaLabel: "next"
  })))), (selectedVideo?.youTubeId || selectedVideo?.lightboxUrl) && /*#__PURE__*/_react.default.createElement(_index2.default, {
    dataCy: 'video-gallery-section-lightbox',
    youTubeId: selectedVideo?.youTubeId,
    lightboxUrl: selectedVideo?.lightboxUrl,
    showModal: lightBoxIsOpen,
    handleClose: closeLightBox,
    disableAutoPlay: selectedVideo?.disableAutoPlay,
    lightboxCtas: activeItem?.lightboxCtas
  }));
}
var _default = exports.default = VideoGallerySection;
VideoGallerySection.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  sectionHeading: _propTypes.default.string,
  cards: _propTypes.default.arrayOf(_propTypes.default.shape({
    heading: _propTypes.default.string,
    invert: _propTypes.default.bool,
    portrait: _propTypes.default.object,
    landscape: _propTypes.default.object,
    thumbnailDesktop: _propTypes.default.string,
    thumbnailMobile: _propTypes.default.string,
    introUrl: _propTypes.default.string,
    introUrlWebm: _propTypes.default.string,
    introUrlLaptop: _propTypes.default.string,
    introUrlLaptopWebm: _propTypes.default.string,
    preload: _propTypes.default.bool,
    youTubeId: _propTypes.default.string,
    lightboxUrl: _propTypes.default.string,
    captionText: _propTypes.default.string,
    disableAutoPlay: _propTypes.default.bool,
    transcriptButton: _propTypes.default.object,
    ctas: _propTypes.default.array
  })),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  ..._boxModelSize.marginProps
};